import { useState } from "react";
import { toast } from "sonner";
import { Facebook, Link2, Check, MessageCircle } from "lucide-react";
import { API } from "@/lib/api";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.78h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.89 9.88m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.33.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.9 11.9 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.33 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41" />
  </svg>
);

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export const CardShareButtons = ({ card, index, total }) => {
  const [copied, setCopied] = useState(false);
  const url = `${API}/cards/${card.id}/share`;
  const text = `${card.title ? `${card.title} — ` : ""}ROAN talking card ${index + 1} of ${total}. If not you, then who?`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (_) {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
    return true;
  };

  const messenger = async () => {
    if (isMobile()) {
      window.location.href = `fb-messenger://share/?link=${encodeURIComponent(url)}`;
      return;
    }
    await copy();
    toast.success("Link copied — paste it into Messenger");
  };

  const cls = "inline-flex items-center justify-center w-9 h-9 rounded-full border border-[#FDFBF7]/20 text-[#FDFBF7] hover:border-[#E2705A] hover:bg-[#E2705A] transition-colors";
  return (
    <div className="flex items-center gap-1.5" data-testid="card-share-buttons">
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" data-testid="card-share-facebook" className={cls} title="Share on Facebook"><Facebook className="w-4 h-4" /></a>
      <button type="button" onClick={messenger} data-testid="card-share-messenger" className={cls} title="Send in Messenger"><MessageCircle className="w-4 h-4" /></button>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`} target="_blank" rel="noopener noreferrer" data-testid="card-share-whatsapp" className={cls} title="Share on WhatsApp"><WhatsAppIcon className="w-4 h-4" /></a>
      <button type="button" onClick={copy} data-testid="card-share-copy" className={cls} title="Copy link">{copied ? <Check className="w-4 h-4 text-[#8FA58A]" /> : <Link2 className="w-4 h-4" />}</button>
    </div>
  );
};
